<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="enabled">{{ $tc('page.generic.state', 1) }} <required-field /></label> <br>
                <custom-switch
                  id="enabled"
                  class="mx-1"
                  v-model="source.enabled"
                  color="success"
                  variant="pill"
                  label/>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="code">{{ $t('page.generic.code') }}</label>
                <b-form-input
                  aria-describedby="codeField"
                  :disabled="true"
                  :state="errors.some((e) => e.field === 'code') ? false : null"
                  type="text"
                  id="code"
                  v-model="source.code"
                  aria-required="true">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="label">{{ $t('page.generic.name') }} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="source.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="timeToLive">{{ $t('source.timeToLive') }} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="number" id="timeToLive" v-model="source.timeToLive" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="description">{{ $t('page.generic.description') }}</label>
                <b-form-textarea aria-describedby="description" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="source.description"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="createSource">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'sourceRoute'}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr' //ES6
import PageTitle from '@/components/PageTitle'
import RequiredField from "../../components/RequiredField";
import SourceService from "@/services/SourceService";
import CustomSwitch from '../../components/CustomSwitch'

const sourceService = SourceService.build();

export default {
  name: 'SourceNew',
  inheritAttrs: false,
  components: {
    RequiredField,
    PageTitle,
    CustomSwitch
  },
  data() {
    return {
      source: {
        enabled: false
      },
      errors: []
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
  },
  methods: {
    async createSource() {
      try {
        const newSource = await sourceService.create(this.source);
        this.$router.push({name: `sourceShowRoute`, params: {id: newSource.id}})
      } catch (exception) {
        this.errors = exception.errors;
        exception.errors.forEach(function (element) {
          miniToastr.error(element.message);
        });
      }
    }
  }
}
</script>

